import { useState, useEffect, useRef } from 'react';

const TruncatedButton = ({ text, maxWidth = 120, startChars = 10, endChars = 3, buttonClass, handleClick, isActive, ...props }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [buttonWidth, setButtonWidth] = useState(maxWidth);
  const buttonRef = useRef(null);
  const textRef = useRef(null);

  const truncateText = (text) => {
    if (text.length <= startChars + endChars + 3) return text;
    return `${text.slice(0, startChars)}...${text.slice(-endChars)}`;
  };

  useEffect(() => {
    const checkTextOverflow = () => {
      if (textRef.current && buttonRef.current) {
        const textWidth = textRef.current.offsetWidth;
        const isOverflowing = textWidth > maxWidth;
        setIsTruncated(isOverflowing);
        setButtonWidth(Math.min(Math.max(textWidth + 16, 60), maxWidth)); // +16 pour le padding
      }
    };

    checkTextOverflow();
    window.addEventListener('resize', checkTextOverflow);
    return () => window.removeEventListener('resize', checkTextOverflow);
  }, []);

  return (
    <button
      ref={buttonRef} className={buttonClass} onClick={handleClick}
      style={{
        width: isActive ? 'fit-content' : `${buttonWidth}px`,
        maxWidth: `${isActive ? '1000' : maxWidth}px`,
        overflow: 'hidden',
        // textOverflow: 'ellipsis',
        minWidth: `auto`,
        alignItems: 'center',
        whiteSpace: 'nowrap',
      }}
      title={text}
      {...props}
    >
      <span ref={textRef}>
        {(isTruncated && !isActive) ? truncateText(text) : text}
      </span>
    </button>
  );
};

export default TruncatedButton;